import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Mail, Clock, MapPin } from "lucide-react";
import { A, CONTACT, COMPANY, MAPS_URL, DOCS_URL } from "../config";
import { to } from "../data";

const COLS = [
  ["Products", [["upiqr", "UPI QR Payments"], ["soundbox", "UPI Soundbox"], ["gateway", "UPI Payment Gateway"], ["invoicing", "Invoicing & GST Billing"], ["accounting", "Business Accounting"], ["pos", "POS & Inventory Management"]]],
  ["Solutions", [["sol-retail", "Retail Stores"], ["sol-ecommerce", "E-commerce"], ["sol-saas", "SaaS Platforms"], ["sol-education", "Education"], ["sol-bfsi", "BFSI"], ["sol-freelancers", "Freelancers"]]],
  ["Company", [["about", "About Us"], ["contact", "Contact Us"], ["contact", "Partnerships"], ["@docs", "API Documentation"]]],
  ["Legal", [["privacy", "Privacy Policy"], ["terms", "Terms & Conditions"], ["onboarding", "Merchant Onboarding Policy"], ["refund", "Refund & Dispute Policy"], ["grievance", "Grievance Redressal"], ["prohibited", "Prohibited & Restricted Merchants"], ["aml", "AML & KYC Policy"]]],
];

export default function Footer() {
  const { pathname } = useLocation();
  return (
    <footer>
      <div className="w">
        {!["/contact-us", "/about-us", "/upi-qr", "/upi-soundbox", "/upi-payment-gateway"].includes(pathname) && !pathname.startsWith("/solutions/") && !pathname.startsWith("/products/") && (
        <div className="band">
          <div>
            <h3>Let&apos;s build your payment experience</h3>
            <p>Talk to our team about UPI QR, Soundbox and payment gateway solutions.</p>
          </div>
          <Link className="btn p" to="/contact-us">Contact Sales <ArrowRight size={16} /></Link>
        </div>
        )}
        <div className="fg">
          <div>
            <img className="lgi" src={A + "logo-white.png"} alt="Formax Connect" width="170" height="33" />
            <p>Payment technology and merchant infrastructure platform for businesses, platforms and enterprises.</p>
            <div className="fc">
              <div className="fci"><Mail size={16} /><span><b>Merchant Support</b><a href={"mailto:" + CONTACT.support}>{CONTACT.support}</a></span></div>
              <div className="fci"><Mail size={16} /><span><b>Sales &amp; Partnerships</b><a href={"mailto:" + CONTACT.partner}>{CONTACT.partner}</a></span></div>
              <div className="fci"><Clock size={16} /><span><b>Business Hours</b>Monday – Saturday<br />9:00 AM – 6:00 PM IST<br />Sunday: Closed</span></div>
              <div className="fci"><MapPin size={16} /><span><b>Office Address</b><a href={MAPS_URL} target="_blank" rel="noopener noreferrer">{CONTACT.addressLines.map((l, i) => <React.Fragment key={l}>{i > 0 && <br />}{l}</React.Fragment>)}</a></span></div>
            </div>
          </div>
          {COLS.map(([h, links]) => (
            <div key={h}>
              <h4>{h}</h4>
              {links.map(([k, t]) => (k === "@docs" ? <a key={t} href={DOCS_URL} target="_blank" rel="noopener noreferrer">{t}</a> : <Link key={t} to={to(k)}>{t}</Link>))}
            </div>
          ))}
        </div>
        <div className="wm" aria-hidden="true">Formax Connect</div>
        <div className="bt">
          <p>{COMPANY.legal} · CIN: {COMPANY.cin} · GSTIN: {COMPANY.gstin} · Incorporated 2018</p>
          <p className="disc">Formax Connect is a technology service provider operated by FORMAX IT SOLUTIONS PRIVATE LIMITED. We provide API-driven payment technology solutions and do not independently offer payment aggregation services or hold merchant/customer funds. Regulated financial services are provided by authorized institutions, subject to eligibility and applicable approvals.</p>
          <p>© {new Date().getFullYear()} {COMPANY.legal}.</p>
        </div>
      </div>
    </footer>
  );
}
